// Generated from SVG to Code Figma Plugin

export const ProductLineSubject = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M4.57617 7.8501L12.0001 12.1167L19.4241 7.8501"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M12 19.65V12.1167" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M5.44662 6.48368L10.5007 3.56573C11.4289 3.02983 12.5724 3.02983 13.5007 3.56573L18.5547 6.48368C19.4829 7.01958 20.0547 8.00996 20.0547 9.08176V14.9177C20.0547 15.9895 19.4829 16.9798 18.5547 17.5157L13.5007 20.4337C12.5724 20.9696 11.4289 20.9696 10.5007 20.4337L9.98714 20.1372L5.44661 17.5157C4.51841 16.9798 3.94662 15.9895 3.94662 14.9177V11.9997V9.08176C3.94662 8.00996 4.51841 7.01958 5.44662 6.48368Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
